import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';

/**
 * PREMIUM LEATHERCRAFT PATTERN COLLECTION™ sales page.
 * HERO → SNAPSHOT → AUDIENCE/PAIN → MESSENGER BAG PREVIEW → 6 LEVELS → STEPS → BONUSES →
 * OFFER → GUARANTEE → TECH PROOF → COST/WHY TODAY → FAQ → FINAL CTA → FOOTER.
 */
const named = <K extends string,>(loader: () => Promise<Record<K, React.ComponentType>>, key: K) => lazy(() => loader().then(m => ({
  default: m[key]
})));
const ValueStrip = named(() => import('./components/sections/ValueStrip'), 'ValueStrip');
const AudiencePainSection = named(() => import('./components/sections/ExtraSections'), 'AudiencePainSection');
const StepsSection = named(() => import('./components/sections/ExtraSections'), 'StepsSection');
const GuaranteeSection = named(() => import('./components/sections/ExtraSections'), 'GuaranteeSection');
const CostSection = named(() => import('./components/sections/ExtraSections'), 'CostSection');
const ProjectPreviewSection = named(() => import('./components/sections/ProjectPreviewSection'), 'ProjectPreviewSection');
const TechProofSection = named(() => import('./components/sections/TechProofSection'), 'TechProofSection');
const CollectionSection = named(() => import('./components/sections/CollectionSection'), 'CollectionSection');
const BonusSection = named(() => import('./components/sections/BonusSection'), 'BonusSection');
const OfferSection = named(() => import('./components/sections/OfferSection'), 'OfferSection');
const FaqSection = named(() => import('./components/sections/FaqSection'), 'FaqSection');
const FinalCta = named(() => import('./components/sections/FinalCta'), 'FinalCta');
const Footer = named(() => import('./components/Footer'), 'Footer');
const StickyBuyBar = named(() => import('./components/StickyBuyBar'), 'StickyBuyBar');
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
  id?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-charcoal',
  id
}: DeferredProps) {
  return <Suspense fallback={<div id={id} className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="34x4zq3nzp7l" />} data-id="element-0" data-mp="35ghusegjner">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full overflow-x-clip bg-charcoal text-white" data-id="element-2" data-mp="d4xqnip0ahey">
      <Hero data-id="element-3" data-mp="85l28tihl2a9" />
      <Deferred minHeight="64px" background="bg-bottle" data-id="element-4" data-mp="851kbcsu6dw8"><ValueStrip data-id="element-5" data-mp="86cnpbiddjmt" /></Deferred>
      <Deferred minHeight="700px" background="bg-ivory" data-id="element-6" data-mp="3gle8mfj3sxdl"><AudiencePainSection data-id="element-7" data-mp="3gm63tp8sgt3c" /></Deferred>
      <Deferred minHeight="900px" background="bg-cream" id="project-preview" data-id="element-8" data-mp="3gj1s86szuv2n"><ProjectPreviewSection data-id="element-9" data-mp="3bnuwbl5yuuoa" /></Deferred>
      <Deferred minHeight="1000px" background="bg-dune" id="volumes" data-id="element-10" data-mp="3qb7jfebf98gs"><CollectionSection data-id="element-11" data-mp="3qcimfbx1mc6u" /></Deferred>
      <Deferred minHeight="400px" background="bg-dune" data-id="element-12" data-mp="3lkhbpufiwtix"><StepsSection data-id="element-13" data-mp="3ljpkswwvfjyz" /></Deferred>
      <Deferred minHeight="900px" background="bg-cream" id="bonuses" data-id="element-14" data-mp="3limsqlntbbhh"><BonusSection data-id="element-15" data-mp="2xtlprdxr0sjl" /></Deferred>
      <Deferred minHeight="900px" id="offer" data-id="element-16" data-mp="2xssj0cysi31g"><OfferSection data-id="element-17" data-mp="2swbpt4cqgyhi" /></Deferred>
      <Deferred minHeight="500px" background="bg-ivory" id="guarantee" data-id="element-18" data-mp="2svagb4bd8k1w"><GuaranteeSection data-id="element-19" data-mp="18d9de7l45msp" /></Deferred>
      <Deferred minHeight="900px" background="bg-cream" id="technical-proof" data-id="element-20" data-mp="18c6q09n022hj"><TechProofSection data-id="element-21" data-mp="1d4rcsr7hnfbk" /></Deferred>
      <Deferred minHeight="700px" background="bg-cream" data-id="element-22" data-mp="1d5ssj8zg8pzm"><CostSection data-id="element-23" data-mp="yg3lwy8l7try" /></Deferred>
      <Deferred minHeight="620px" background="bg-ivory" id="faq" data-id="element-24" data-mp="ygwix7hqv4ww"><FaqSection data-id="element-25" data-mp="13eeuz6r26094" /></Deferred>
      <Deferred minHeight="420px" data-id="element-26" data-mp="13fpxl38rp1yn"><FinalCta data-id="element-27" data-mp="13ey35vqwpa9y" /></Deferred>
      <Deferred minHeight="220px" background="bg-charcoal-deep" data-id="element-28" data-mp="1r496nkzn5irs"><Footer data-id="element-29" data-mp="1r4se27ro0ork" /></Deferred>
      <Suspense fallback={null} data-id="element-30" data-mp="1r2g1690rl4ld"><StickyBuyBar data-id="element-31" data-mp="1w33skvswnng4" /></Suspense>
    </main>;
}